import request from "../../../utils/request";

export const getExternalExpressMappings = '/external/express/';

export function modifyExternalExpressMapping(params: any) {
    return request.request({
        url: '/external/express/',
        method: params.id ? 'put' : "post",
        data: params
    });
}

export function deleteExternalExpressMapping(id: string) {
    return request.request({
        url: '/external/express/',
        method: 'delete',
        params: {mappingId: id}
    })
}

export function importExternalExpressMappings(file: File) {
    const formData = new FormData()
    formData.append("file", file)
    return request.request({
        url: '/external/express/import',
        method: 'post',
        data: formData
    })
}
